import * as React from 'react';
import { PAGE_ITEMS_TO_VIEW } from '@/components/Pagination/helpers/filterSortOptions';
import CatalogGrid from '@/components/CatalogCard/CatalogGrid';
import isEqual from 'react-fast-compare';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import styled from 'styled-components';

type Props = {
    catalogIds?: number[];
    changePageAndNavigate: Function;
    changePageSizeAndNavigate: Function;
    page: number;
    pageSize: number;
    totalItemsFound: number;
    trackUpcomingCatalogClick?: (id: number) => void;
};

const AuctionCalendarResults = (props: Props) => {
    const { catalogIds, changePageAndNavigate, changePageSizeAndNavigate, page, pageSize, totalItemsFound } = props;

    const onChange = ({ page, pageSize }) => {
        if (!Boolean(pageSize)) {
            changePageAndNavigate(page - 1);
        } else {
            changePageSizeAndNavigate(pageSize);
        }
    };

    return (
        <StyledResults>
            <Pagination
                onChange={onChange}
                pageSizeOptions={PAGE_ITEMS_TO_VIEW}
                paginationFilter={{
                    page,
                    pageSize,
                    totalRecords: totalItemsFound,
                }}
                restrictPagesTo={10}
            >
                <StyledCatalogGrid catalogIds={catalogIds} />
            </Pagination>
        </StyledResults>
    );
};

export default React.memo<Props>(AuctionCalendarResults, isEqual);

const StyledResults = styled.div`
    flex: 1 1;
    max-width: 100%;
    position: relative;
`;

const StyledCatalogGrid = styled(CatalogGrid)`
    flex: 1 0 auto;
    margin: 0 -10px;
    width: calc(100% + 20px);
    max-width: calc(100% + 20px);
    min-height: 360px;
`;
